<p>
  След като една обява изтече без да бъде сключена сделка, тя автоматично преминава в неактивен статус и спира да се
  показва публично. За да активирате отново такава обява, е необходимо да я <strong>обновите</strong>. Платформата
  предоставя няколко удобни начина за това.
</p>
<h6 class="mt-3">1. Обновяване от страницата на обявата</h6>
<p>
  Навигирайте до страницата на съответната обява и натиснете бутона <strong>„Обновяване на обявата“</strong>. Ще се
  отвори прозорец, в който трябва да изберете <strong>нова крайна дата и час</strong>, до които желаете обявата да бъде
  отново активна.
</p>
<h6 class="mt-3">2. Обновяване от секцията „Моите обяви“</h6>
<ol>
  <li>Отидете в <strong>„Профил“ → „Моите обяви“</strong>.</li>
  <li>Открийте обявата, която искате да обновите (ще бъде маркирана като изтекла).</li>
  <li>Натиснете бутона с <strong>три точки (⋮)</strong> вдясно и изберете опцията <strong>„Обновяване на
    обявата“</strong>.
  </li>
  <li>Задайте нова крайна дата и потвърдете.</li>
</ol>
<h6 class="mt-3">3. Групово обновяване</h6>
<p>
  Ако управлявате голям брой обяви, функцията за <strong>групово обновяване</strong> ще ви спести време и усилия.
  Навигирайте до <strong>„Профил“ → „Моите обяви“</strong>, натиснете бутона <strong>„Групово обновяване“</strong>,
  изберете желаните обяви и задайте новите дати едновременно.
</p>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> При създаване на нова обява може да активирате опцията <em>„Автоматично обновяване след
  завършване без продажба“</em>. Това ще гарантира, че изтеклата обява ще се поднови автоматично, без ръчно действие.
</div>
